import * as React from "react";
import { DASHBOARD, JOB, BUDGET } from "icons";
import {
  ContractProvider,
  useContract,
} from "./context";
import { Outlet } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import Loader from "@/components/loader";
import { NavItem } from "@/components/nav/item";
import { NavItemWithBadge } from "@/components/nav/nav-item-with-badge";
import { ContractHeader } from "./components/header";
import { CollapsibleContractHeader } from "./components/collapsible-header";
import { PAGE_BANNER_PORTAL_ID } from "utils";

export default function ContractLayout({ children, ...props }) {
  return (
    <ContractProvider>
      <ContractLayoutContent {...props} />
    </ContractProvider>
  );
}
function ContractLayoutContent(props) {
  const { contract, isContractLoading } = useContract();

  if (isContractLoading) {
    return <Loader />;
  }

  if (!contract) return null;

  return (
    <div className="flex-1 flex flex-col relative min-w-0 h-full">
      <ContractHeader />
      <div className="flex flex-1 relative min-w-0 overflow-hidden">
        <SidebarProvider
          className="w-fit overflow-hidden h-full"
          name="project"
        >
          <Sidebar
            collapsible="icon"
            {...props}
            className="sidebar-height border-r left-auto inset-y-auto top-0 mt-28"
          >
            <SidebarHeader className="p-0">
              <div className="p-4">
                <CollapsibleContractHeader contract={contract} isLoading={isContractLoading} />
              </div>
            </SidebarHeader>
            <SidebarContent>
              <SidebarGroup>
                <SidebarMenu>
                  <NavItem
                    title="Dashboard"
                    icon={DASHBOARD}
                    url={`/work/contracts/${contract.id}`}
                    matchExact={true}
                  />
                  <NavItem
                    title="Budget"
                    icon={BUDGET}
                    url={`/work/contracts/${contract.id}/budget`}
                  />
                  <NavItemWithBadge
                    title="Jobs"
                    icon={JOB}
                    url={`/work/contracts/${contract.id}/jobs`}
                  />
                </SidebarMenu>
              </SidebarGroup>
            </SidebarContent>
            <SidebarRail />
          </Sidebar>
        </SidebarProvider>
        <div className="flex flex-1 flex-col min-w-0">
          {/* Page-level banners (portaled in); collapses when empty. */}
          <div
            id={PAGE_BANNER_PORTAL_ID}
            className="flex flex-col gap-2 px-4 pt-4 empty:hidden"
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
